import { render } from "./FormTabGuard.vue?vue&type=template&id=639d7f98"
import script from "./FormTabGuard.vue?vue&type=script&lang=js"
export * from "./FormTabGuard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__